import {
	VelocityClient,
	UnifiedSwapClient,
	BulkAccountLoader,
} from '@velocity-exchange/sdk';
import { Connection } from '@solana/web3.js';
import { useCallback } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { RpcEndpoint } from '@velocity-exchange/common';
import Env from 'src/environmentVariables/EnvironmentVariables';

interface HandleSubscriptionSuccessParams {
	selectedRpc: RpcEndpoint;
	newConnection: Connection;
	newAccountLoader: BulkAccountLoader;
	newDriftClient: VelocityClient;
	newSwapClient: UnifiedSwapClient;
}

export const useHandleSubscriptionSuccess = () => {
	const setDriftStore = useDriftStore((s) => s.set);

	const handleSubscriptionSuccess = useCallback(
		({
			selectedRpc,
			newConnection,
			newAccountLoader,
			newDriftClient,
			newSwapClient,
		}: HandleSubscriptionSuccessParams) => {
			setDriftStore((s) => {
				s.connection.rpc = selectedRpc;
				s.connection.current = newConnection;
				s.connection.accountLoader = newAccountLoader;
				s.driftClient.client = newDriftClient;
				s.currentBulkAccountLoader = newAccountLoader;
				s.swapClient = newSwapClient;
			});

			newConnection.getVersion().then((version) => {
				Env.rpcVersion = version;
			});
		},
		[setDriftStore]
	);

	return { handleSubscriptionSuccess };
};
